import { gql } from 'apollo-angular'

export default gql`
  mutation reset_pw($requesterId: Int!, $userId: Int!) {
    resetPassword(data: { requesterId: $requesterId, userId: $userId })
  }
`
